import React, { useId } from 'react';
import { motion } from 'motion/react';
import styles from './Tabs.module.css';
import { SPRING } from '../../utils/motion';

export default function Tabs({ tabs, activeId, onChange, className = '' }) {
  // layoutId único por instancia para que varias Tabs en pantalla no compartan indicador
  const groupId = useId();

  const hasActive = tabs.some((t) => t.id === activeId);

  const onKeyDown = (e, index) => {
    const last = tabs.length - 1;
    let next = null;
    if (e.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    else if (e.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = last;
    if (next === null) return;
    e.preventDefault();
    onChange(tabs[next].id);
    const buttons = e.currentTarget.parentElement.querySelectorAll('[role="tab"]');
    buttons[next]?.focus();
  };

  return (
    <div className={`${styles.wrap} ${className}`} role="tablist">
      {tabs.map((tab, index) => {
        const isActive = activeId === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            tabIndex={isActive || (!hasActive && index === 0) ? 0 : -1}
            className={`${styles.tab} ${isActive ? styles.active : ''}`}
            onClick={() => onChange(tab.id)}
            onKeyDown={(e) => onKeyDown(e, index)}
          >
            {isActive && (
              <motion.span
                layoutId={`tab-indicator-${groupId}`}
                className={styles.indicator}
                transition={SPRING.bouncy}
              />
            )}
            <span className={styles.label}>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
